import { push } from "connected-react-router";
import { Routes } from "const";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchPerpBondList,
  fetchPerpBondListSuccess,
  fetchPerpBondListFailure,
  selectPerpBond,
  selectPerpBondSuccess,
  selectPerpBondFailure,
} from "redux/reducers/perp-bond";
import { PreTestSection } from "routes/PerpetualBond/const";
import { PerpBondAPI } from "services/perp-bond";

function* fetchPerpBondListSaga() {
  try {
    const response = yield call(PerpBondAPI.fetchPerpBondList);
    yield put(fetchPerpBondListSuccess(response.data.result.preSubTestSecuritiesComplexList));
  } catch (error) {
    console.error(error);
    yield put(fetchPerpBondListFailure(error));
  }
}

function* getPerpBondDetailSaga({ payload }) {
  try {
    const response = yield call(PerpBondAPI.getPerpBondDetail, payload);
    const { preSubTestSecuritiesDetail } = response.data.result;
    //* currently pre-test page itself, fetch only primary product pre-test suit!!!
    //* if not then dynamic the secion config below.
    preSubTestSecuritiesDetail.section = PreTestSection.PrimaryMarket;
    yield put(selectPerpBondSuccess(preSubTestSecuritiesDetail));
    yield put(push(`${Routes.PerpetualBond}/check-list`));
  } catch (error) {
    console.error(error);
    yield put(selectPerpBondFailure(error));
  }
}

const saga = [
  takeLatest(fetchPerpBondList.type, fetchPerpBondListSaga),
  takeLatest(selectPerpBond.type, getPerpBondDetailSaga),
];

export default saga;
